import Infinite from "./Infinite";
import Weekly from "./Weekly";
import { Fragment, useState } from "react";
import { Button, ButtonGroup } from "@mui/material";
export default function Scheduler() {
  const [view, setView] = useState("Infinite");
  const CustomButton = ({ value }) => {
    return (
      <Button
        variant={view === value ? "contained" : "outlined"}
        onClick={() => setView(value)}
      >
        {value}
      </Button>
    );
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {/* <div style={{ position: "absolute", top: 0, right: 0 }}>
        <ButtonGroup>
          <CustomButton value="Infinite" />
          <CustomButton value="Week" />
        </ButtonGroup>
      </div> */}
      {view === "Infinite" && <Infinite />}
      {view === "Week" && <Weekly />}
    </div>
  );
}
